import { axios } from '@Root/API'

export const getCountries = () => {
	return axios.get('countries')
}
